import { createReducer } from 'redux-act';
import { PURGE } from 'redux-persist';

import {
    userSubjectUpdate,
    roomUpdate,
    timeslotUpdate,
    blockUpdate,
    startDateUpdate,
    recurrenceUpdate,
    newTimeslotLoad,
    newTimeslotReset,
    durationUpdate
} from 'actions/new-timeslot';

const defaultState = {
    user_subject_id: null,
    room: '',
    start_date: '',
    recurrence: 'weekly',
    timeslot: '',
    duration: '1',
    block: 0
};

const newTimeslot = createReducer({
    [userSubjectUpdate]: (state, payload) => ({
        ...state,
        user_subject_id: payload.userSubject
    }),
    [roomUpdate]: (state, payload) => ({
        ...state,
        room: payload.room
    }),
    [startDateUpdate]: (state, payload) => ({
        ...state,
        start_date: payload.start_date
    }),
    [recurrenceUpdate]: (state, payload) => ({
        ...state,
        recurrence: payload.recurrence
    }),
    [timeslotUpdate]: (state, payload) => ({
        ...state,
        timeslot: payload.timeslot
    }),
    [durationUpdate]: (state, payload) => ({
        ...state,
        duration: payload.duration
    }),
    [blockUpdate]: (state, payload) => ({
        ...state,
        block: payload.block
    }),
    [newTimeslotLoad]: (state, payload) => ({
        ...state,
        ...payload
    }),
    [newTimeslotReset]: () => defaultState,
    [PURGE]: () => defaultState
}, defaultState);

export default newTimeslot;